<input class="form-control" type="number" v-model="inputValue" @blur="blur">